export const testMobile = () => { // is mobile or not
	return typeof window !== 'undefined' ? ((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)) : false;
};

export const demo = () => {};
